import type {IssueEventItem} from '../../../../page-data/payloads/timeline'

function shortOid(oid: string): string {
  return oid.slice(0, 7)
}

export function MergedText({item}: {item: IssueEventItem}) {
  const {commitOid} = item.additionalInfo
  if (!commitOid) return <>merged</>
  return (
    <>
      merged commit <strong>{shortOid(commitOid)}</strong>
    </>
  )
}
